/**
 * Eager bit of duels for the map rail: two shopping bags clashing over a spark (inline SVG in
 * the overlay's toon icon style until the atlas has an `ico_duel`: sharedRequests).
 */
import type { JSX } from 'preact';

const INK = '#4a2c2a';

export function DuelMark({ size = 26 }: { size?: number }): JSX.Element {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" aria-hidden="true">
      <path d="M16 3l1.8 3.8 4.2.6-3 2.9.7 4.1-3.7-2-3.7 2 .7-4.1-3-2.9 4.2-.6z" fill="#ffc845" stroke={INK} stroke-width="1.6" stroke-linejoin="round" />
      <g transform="rotate(-14 9 21)">
        <path d="M3.5 15h11l-1 13h-9z" fill="#ff6b5b" stroke={INK} stroke-width="2" stroke-linejoin="round" />
        <path d="M6.5 15v-2a2.5 2.5 0 0 1 5 0v2" fill="none" stroke={INK} stroke-width="1.8" stroke-linecap="round" />
      </g>
      <g transform="rotate(14 23 21)">
        <path d="M17.5 15h11l-1 13h-9z" fill="#2ec4b6" stroke={INK} stroke-width="2" stroke-linejoin="round" />
        <path d="M20.5 15v-2a2.5 2.5 0 0 1 5 0v2" fill="none" stroke={INK} stroke-width="1.8" stroke-linecap="round" />
      </g>
    </svg>
  );
}
